/* ESK collection sorting (Oct 19 2026)
 * - curated Sort by list (adds 'Biggest discount', drops A-Z / Z-A / oldest)
 * - 'best-discount' = highest % off compare-at price, then biggest $ saved
 * - in-stock products first across ALL pages for every sort (replaces old inline reorder)
 */
(function () {
  var OPTIONS = [
    ['manual', 'Recommended'],
    ['best-discount', 'Biggest discount'],
    ['best-selling', 'Best sellers'],
    ['price-ascending', 'Price: low to high'],
    ['price-descending', 'Price: high to low'],
    ['created-descending', 'Newest arrivals']
  ];
  var runId = 0;

  function params() {
    var s = (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.searchParamsPrev === 'string')
      ? FacetFiltersForm.searchParamsPrev
      : window.location.search.slice(1);
    return new URLSearchParams(s);
  }

  function currentSort(grid) {
    return params().get('sort_by') || (grid && grid.dataset.defaultSort) || 'manual';
  }

  function normalizeSelects(sort) {
    document.querySelectorAll('select[name=sort_by]').forEach(function (sel) {
      if (sel.dataset.eskSort === sort) return;
      var labels = {};
      Array.prototype.forEach.call(sel.options, function (o) { labels[o.value] = o.textContent.trim(); });
      var list = OPTIONS.slice();
      if (!list.some(function (o) { return o[0] === sort; })) list.push([sort, labels[sort] || sort]);
      sel.innerHTML = '';
      list.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o[0];
        opt.textContent = o[1];
        if (o[0] === sort) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.value = sort;
      sel.dataset.eskSort = sort;
    });
  }

  function num(li, k) { return parseFloat(li.dataset[k]) || 0; }

  function sortItems(items, sort) {
    items.forEach(function (li, i) { li.__eskIndex = i; });
    return items.sort(function (a, b) {
      var d = (b.dataset.available === 'true') - (a.dataset.available === 'true');
      if (d) return d;
      if (sort === 'best-discount') {
        d = num(b, 'discount') - num(a, 'discount');
        if (d) return d;
        d = num(b, 'save') - num(a, 'save');
        if (d) return d;
      }
      return a.__eskIndex - b.__eskIndex;
    });
  }

  function show(grid) {
    grid.classList.remove('product-grid--hidden');
    grid.classList.add('product-grid--visible');
  }

  function run() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var sort = currentSort(grid);
    normalizeSelects(sort);
    var my = ++runId;
    var pages = parseInt(grid.dataset.pages, 10) || 1;

    if (pages <= 1) {
      var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item[data-handle]'));
      if (sort === 'best-discount' && items.length > 1) {
        sortItems(items, sort).forEach(function (li) { grid.appendChild(li); });
      }
      show(grid);
      return;
    }

    var perPage = parseInt(grid.dataset.perPage, 10) || 20;
    var page = parseInt(grid.dataset.page, 10) || 1;
    var sectionId = grid.dataset.id;
    var base = params();
    var urls = [];
    for (var p = 1; p <= pages; p++) {
      var q = new URLSearchParams(base.toString());
      q.set('page', p);
      q.set('section_id', sectionId);
      urls.push(window.location.pathname + '?' + q.toString());
    }

    Promise.all(urls.map(function (u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    }))
      .then(function (htmls) {
        if (my !== runId) return;
        var parser = new DOMParser();
        var seen = new Set();
        var all = [];
        htmls.forEach(function (html) {
          parser.parseFromString(html, 'text/html')
            .querySelectorAll('#product-grid > li.grid__item[data-handle]')
            .forEach(function (li) {
              var h = li.dataset.handle;
              if (!h || seen.has(h)) return;
              seen.add(h);
              all.push(li);
            });
        });
        var slice = sortItems(all, sort).slice((page - 1) * perPage, page * perPage);
        if (slice.length) {
          grid.innerHTML = '';
          slice.forEach(function (li) { grid.appendChild(li); });
        }
      })
      .catch(function (err) { console.warn('ESK collection sort failed:', err); })
      .finally(function () { if (my === runId) show(grid); });
  }

  // Re-run after facets.js swaps the grid (sort / filter changes without reload)
  if (typeof FacetFiltersForm !== 'undefined' && !FacetFiltersForm.__eskSort) {
    var orig = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig.call(FacetFiltersForm, html);
      run();
    };
    FacetFiltersForm.__eskSort = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
